import { Container, Carousel } from 'react-bootstrap'
import TituloNegrito from './TituloNegrito'

import { retornarTexto } from '../helpers/textoHelper'

function Imagens({ imagens, resolucaoMobile, idioma }) {
    const dimensionsImage = resolucaoMobile ? '300px' : '400px'
    const stylesImage = { width: dimensionsImage, height: dimensionsImage, objectFit: 'cover', borderRadius: '8px' }

    return (
        <>
            <TituloNegrito texto={retornarTexto(idioma, 'imagens')} />
            <Container className="d-flex align-items-center justify-content-center mb-5">
                <Carousel interval={null} style={{ height: '500px', width: '700px' }} controls indicators className="animate__animated animate__fadeIn d-flex align-items-center justify-content-center">
                    {imagens.map((imagem) => (
                        <Carousel.Item key={imagem.id}>
                            {imagem['Link ao clicar na imagem'] ? (
                                <a href={imagem['Link ao clicar na imagem']} target="_blank" rel="noopener noreferrer">
                                    <img
                                        style={stylesImage}
                                        src={imagem['Link da imagem']}
                                        alt={`Imagem`}
                                    />
                                </a>
                            ) : (
                                <img
                                    style={stylesImage}
                                    src={imagem['Link da imagem']}
                                    alt={`Imagem`}
                                />
                            )}
                        </Carousel.Item>
                    ))}
                </Carousel>
            </Container>
        </>
    )
}

export default Imagens